/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { OfferPrintCreationResponseDto } from '../models';
// @ts-ignore
import type { OfferPrintSearchRequestDto } from '../models';
// @ts-ignore
import type { OfferPrintSearchResponseDto } from '../models';
// @ts-ignore
import type { OfferPrintStatusDto } from '../models';
// @ts-ignore
import type { OfferPrintUpdateStatusRequestDto } from '../models';
/**
 * RestOfferPrintApi - axios parameter creator
 */
export const RestOfferPrintApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new offer print template
         * @param {string} name 
         * @param {OfferPrintStatusDto} status 
         * @param {number} pageNumber 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferPrint: async (name: string, status: OfferPrintStatusDto, pageNumber: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createOfferPrint', 'name', name)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('createOfferPrint', 'status', status)
            // verify required parameter 'pageNumber' is not null or undefined
            assertParamExists('createOfferPrint', 'pageNumber', pageNumber)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createOfferPrint', 'file', file)
            const localVarPath = `/api/offer-prints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }

            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }

            if (pageNumber !== undefined) { 
                localVarFormParams.append('pageNumber', pageNumber as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the end (outro) part of the offer print template PDF
         * @param {number} offerPrintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferPrintPdfEnd: async (offerPrintId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPrintId' is not null or undefined
            assertParamExists('getOfferPrintPdfEnd', 'offerPrintId', offerPrintId)
            const localVarPath = `/api/offer-prints/{offerPrintId}/pdf/end`
                .replace('{offerPrintId}', encodeURIComponent(String(offerPrintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the start (intro) part of the offer print template PDF
         * @param {number} offerPrintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferPrintPdfStart: async (offerPrintId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPrintId' is not null or undefined
            assertParamExists('getOfferPrintPdfStart', 'offerPrintId', offerPrintId)
            const localVarPath = `/api/offer-prints/{offerPrintId}/pdf/start`
                .replace('{offerPrintId}', encodeURIComponent(String(offerPrintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search offer print templates
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferPrintSearchRequestDto} offerPrintSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOfferPrints: async (page: number, pageSize: number, offerPrintSearchRequestDto: OfferPrintSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchOfferPrints', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchOfferPrints', 'pageSize', pageSize)
            // verify required parameter 'offerPrintSearchRequestDto' is not null or undefined
            assertParamExists('searchOfferPrints', 'offerPrintSearchRequestDto', offerPrintSearchRequestDto)
            const localVarPath = `/api/offer-prints/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerPrintSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update status of an offer print template
         * @param {number} offerPrintId 
         * @param {OfferPrintUpdateStatusRequestDto} offerPrintUpdateStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferPrintStatus: async (offerPrintId: number, offerPrintUpdateStatusRequestDto: OfferPrintUpdateStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerPrintId' is not null or undefined
            assertParamExists('updateOfferPrintStatus', 'offerPrintId', offerPrintId)
            // verify required parameter 'offerPrintUpdateStatusRequestDto' is not null or undefined
            assertParamExists('updateOfferPrintStatus', 'offerPrintUpdateStatusRequestDto', offerPrintUpdateStatusRequestDto)
            const localVarPath = `/api/offer-prints/{offerPrintId}/status`
                .replace('{offerPrintId}', encodeURIComponent(String(offerPrintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerPrintUpdateStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestOfferPrintApi - functional programming interface
 */
export const RestOfferPrintApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestOfferPrintApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new offer print template
         * @param {string} name 
         * @param {OfferPrintStatusDto} status 
         * @param {number} pageNumber 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOfferPrint(name: string, status: OfferPrintStatusDto, pageNumber: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferPrintCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOfferPrint(name, status, pageNumber, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintApi.createOfferPrint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the end (outro) part of the offer print template PDF
         * @param {number} offerPrintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferPrintPdfEnd(offerPrintId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferPrintPdfEnd(offerPrintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintApi.getOfferPrintPdfEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the start (intro) part of the offer print template PDF
         * @param {number} offerPrintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferPrintPdfStart(offerPrintId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferPrintPdfStart(offerPrintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintApi.getOfferPrintPdfStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search offer print templates
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferPrintSearchRequestDto} offerPrintSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOfferPrints(page: number, pageSize: number, offerPrintSearchRequestDto: OfferPrintSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferPrintSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOfferPrints(page, pageSize, offerPrintSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintApi.searchOfferPrints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update status of an offer print template
         * @param {number} offerPrintId 
         * @param {OfferPrintUpdateStatusRequestDto} offerPrintUpdateStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferPrintStatus(offerPrintId: number, offerPrintUpdateStatusRequestDto: OfferPrintUpdateStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferPrintStatus(offerPrintId, offerPrintUpdateStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferPrintApi.updateOfferPrintStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestOfferPrintApi - factory interface
 */
export const RestOfferPrintApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestOfferPrintApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new offer print template
         * @param {string} name 
         * @param {OfferPrintStatusDto} status 
         * @param {number} pageNumber 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferPrint(name: string, status: OfferPrintStatusDto, pageNumber: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintCreationResponseDto> {
            return localVarFp.createOfferPrint(name, status, pageNumber, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the end (outro) part of the offer print template PDF
         * @param {number} offerPrintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferPrintPdfEnd(offerPrintId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getOfferPrintPdfEnd(offerPrintId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the start (intro) part of the offer print template PDF
         * @param {number} offerPrintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferPrintPdfStart(offerPrintId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getOfferPrintPdfStart(offerPrintId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search offer print templates
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OfferPrintSearchRequestDto} offerPrintSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOfferPrints(page: number, pageSize: number, offerPrintSearchRequestDto: OfferPrintSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintSearchResponseDto> {
            return localVarFp.searchOfferPrints(page, pageSize, offerPrintSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update status of an offer print template
         * @param {number} offerPrintId 
         * @param {OfferPrintUpdateStatusRequestDto} offerPrintUpdateStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferPrintStatus(offerPrintId: number, offerPrintUpdateStatusRequestDto: OfferPrintUpdateStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOfferPrintStatus(offerPrintId, offerPrintUpdateStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestOfferPrintApi - interface
 */
export interface RestOfferPrintApiInterface {
    /**
     * 
     * @summary Create a new offer print template
     * @param {string} name 
     * @param {OfferPrintStatusDto} status 
     * @param {number} pageNumber 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOfferPrint(name: string, status: OfferPrintStatusDto, pageNumber: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintCreationResponseDto>;

    /**
     * 
     * @summary Download the end (outro) part of the offer print template PDF
     * @param {number} offerPrintId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferPrintPdfEnd(offerPrintId: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Download the start (intro) part of the offer print template PDF
     * @param {number} offerPrintId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferPrintPdfStart(offerPrintId: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Search offer print templates
     * @param {number} page 
     * @param {number} pageSize 
     * @param {OfferPrintSearchRequestDto} offerPrintSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchOfferPrints(page: number, pageSize: number, offerPrintSearchRequestDto: OfferPrintSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferPrintSearchResponseDto>;

    /**
     * 
     * @summary Update status of an offer print template
     * @param {number} offerPrintId 
     * @param {OfferPrintUpdateStatusRequestDto} offerPrintUpdateStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferPrintStatus(offerPrintId: number, offerPrintUpdateStatusRequestDto: OfferPrintUpdateStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestOfferPrintApi - object-oriented interface
 */
export class RestOfferPrintApi extends BaseAPI implements RestOfferPrintApiInterface {
    /**
     * 
     * @summary Create a new offer print template
     * @param {string} name 
     * @param {OfferPrintStatusDto} status 
     * @param {number} pageNumber 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOfferPrint(name: string, status: OfferPrintStatusDto, pageNumber: number, file: File, options?: RawAxiosRequestConfig) {
        return RestOfferPrintApiFp(this.configuration).createOfferPrint(name, status, pageNumber, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the end (outro) part of the offer print template PDF
     * @param {number} offerPrintId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferPrintPdfEnd(offerPrintId: number, options?: RawAxiosRequestConfig) {
        return RestOfferPrintApiFp(this.configuration).getOfferPrintPdfEnd(offerPrintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the start (intro) part of the offer print template PDF
     * @param {number} offerPrintId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferPrintPdfStart(offerPrintId: number, options?: RawAxiosRequestConfig) {
        return RestOfferPrintApiFp(this.configuration).getOfferPrintPdfStart(offerPrintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search offer print templates
     * @param {number} page 
     * @param {number} pageSize 
     * @param {OfferPrintSearchRequestDto} offerPrintSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchOfferPrints(page: number, pageSize: number, offerPrintSearchRequestDto: OfferPrintSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferPrintApiFp(this.configuration).searchOfferPrints(page, pageSize, offerPrintSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update status of an offer print template
     * @param {number} offerPrintId 
     * @param {OfferPrintUpdateStatusRequestDto} offerPrintUpdateStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferPrintStatus(offerPrintId: number, offerPrintUpdateStatusRequestDto: OfferPrintUpdateStatusRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferPrintApiFp(this.configuration).updateOfferPrintStatus(offerPrintId, offerPrintUpdateStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

